import { CheckBolderIcon, Flex, useStyledTheme } from '@equifinance/shared';
import styled from 'styled-components';
import CrossIcon from '../Icons/CrossIcon';

const Icon = styled.i`${({ theme }) => `
  font-size:${theme.fontSize[4]};
  color:${theme.colours.neutral[10]};
`}`;

export const DeleteIcon = styled(Icon).attrs(() => ({
  className: 'mi-delete',
}))` ${({ theme }) => `
  color:${theme.colours.neutral[2]};
`}`;

export const RowDeleteIcon = styled(DeleteIcon)` ${({ theme }) => `
  color:${theme.colours.primary[1]};
`}`;

export const PlusIcon = styled(Icon).attrs(() => ({
  className: 'mi-add',
}))` ${({ theme }) => `
  color:${theme.colours.primary[1]};
`}`;

export const LockIcon = styled(Icon).attrs(() => ({
  className: 'mi-lock',
}))` ${({ theme }) => `
  color:${theme.colours.neutral[5]};
`}`;

export const IconCircle = styled(Flex)`${({ theme }) => `
  width: ${theme.padding[5]};
  height: ${theme.padding[5]};
  border-radius: calc(${theme.padding[5]}/2);
  background: ${theme.colours.primary[1]};
  justify-content: center;
  align-items: center;
`}`;

export const IconCircleInverted = styled(IconCircle)`${({ theme }) => `
  background: ${theme.colours.neutral[10]};
`}`;

export const IconCircleWarning = styled(IconCircle)`${({ theme }) => `
  background: ${theme.colours.secondary[1]};
`}`;

export function TickCircleIcon() {
  return (
    <IconCircle>
      <CheckBolderIcon width="10" height="8" />
    </IconCircle>
  );
}

export function TickCircleIconInverted() {
  const theme = useStyledTheme();
  return (
    <IconCircleInverted>
      <CheckBolderIcon width="10" height="8" fill={theme.colours.primary[1]} />
    </IconCircleInverted>
  );
}

export function TickPurpleCircleIconInverted() {
  const theme = useStyledTheme();
  return (
    <IconCircleInverted>
      <CheckBolderIcon width="10" height="8" fill={theme.colours.warning[3]} />
    </IconCircleInverted>
  );
}

export function CrossCircleIcon() {
  return (
    <Flex>
      <CrossIcon />
    </Flex>
  );
}

export function CrossCircleIconInverted() {
  const theme = useStyledTheme();

  return (
    <Flex>
      <CrossIcon background={theme.colours.neutral[10]} fill={theme.colours.warning[3]} />
    </Flex>
  );
}
